import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Hyperlink } from 'ascedia-design-system/lib/models/hyperlink.interface';
import { SharedModule } from '../shared.module';
//import { CartService } from './cart.service';
import {environment} from '../../../environments/environment';
import { BookingStatusEnum } from '../models/booking-status.enum';
import { UserRolesEnum } from '../models/user-roles-enum';
//MODELS
//import { Zxcv } from '../models/zxcv.interface';

const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class ConfigService {

	//public test: string = 'dateIs: ';

	//public isProduction = environment.production;

	public colors: any = {
		primary: '#0D5487',
		secondary: '#093B5F',
	}

	public breakpoints: any = {
		md: 768
	}

	public isDirtyAlert = 'There are unsaved changes! Are you sure?';// you want to leave

	//dev:  https://app-compassassets-dev.azureedge.net/assets/destinations/0f9129f8-615f-49db-98fe-08d9e1de1bf6/512x512.png?w=250&h=400&mode=crop&scale=both
	//prod: https://app-compasstoursassets.azurewebsites.net/assets/destinations/9504e913-b2f5-4fc6-d494-08d9bb820fa6/147766812_m.jpg

	public images: any = {
		defaultImage: environment.compassAssetsBaseUrl + 'misc/default-image-20220421.jpg',
		atSea: environment.compassAssetsBaseUrl + 'misc/out-at-sea.png',
		noExcursions: environment.compassAssetsBaseUrl + 'misc/no-excursions-offered.png'
	}


	/**
	 * master list of urls
	*/
	public urls = {
		baseUrl: environment.compassApiBaseUrl,
		basePhotoUrl: environment.compassAssetsBaseUrl, //'https://app-compassassets-dev.azureedge.net/assets/',
		bookings: {
			bookings: '/bookings/bookings',
			carts: '/bookings/carts',
			orders: '/bookings/orders',
			customers: '/bookings/customers',
		},
		configure: {
			currency: '/configure/currency',
			destinations: '/configure/destinations',
			postPurchaseVariants: '/configure/post-purchase-variants',
			regions: '/configure/regions',
		},
		products: {
			excursions: '/excursions',
			reviews: '/reviews'
		},
		vendors: '/vendors',
		vouchers: '/vouchers',
	}


	/**
	 * standard limit max for returned results
	*/
	public limitMax: number = 999;



	public pageTitleBase: string = 'Compass Tours';

	public MainMenuNavItems: Hyperlink[] = [
		{
			title: 'Destinations',
			href: '/destinations',
			level: 1,
			className: 'ml-lg-auto'
		},
		{
			title: 'Support',
			href: '/support',
			level: 1,
			//roles: [UserRolesEnum.admin],
			isVisible: false,
			children: [
				{
					title: 'How it Works',
					href: '/support/how-it-works',
					level: 2,
					//icon: 'globe'
				},
				{
					title: 'Contact Us',
					href: '/support/contact-us',
					level: 2,
					//icon: 'comments'//,
					//badge: 44
				},
				{
					title: 'FAQ',
					href: '/support/faq',
					level: 2
				}
			]
		},
		{
			title: 'About Us',
			href: '/about-us',
			level: 1,
			isVisible: false,
			children: [
				{
					title: 'Our Story',
					href: '/about-us/our-story',
					level: 2,
					//icon: 'globe'
				},
				{
					title: 'Security',
					href: '/about-us/security',
					level: 2
				}
			]
		},
		{
			title: 'Groups',
			href: '/groups',
			level: 1
		},
		{
			title: 'Account',
			icon: 'user-circle',
			iconPrefix: 'fal',
			href: '#',
			className: 'ml-lg-auto utility',
			level: 1,
			isVisible: false,
			children: [
				{
					title: 'Sign In',
					// icon: 'user-circle',
					// iconPrefix: 'fal',
					href: '#',
					className: 'ml-lg-auto utility',
					level: 1,
					isVisible: false
				},
				{
					title: 'Create Account',
					// icon: 'user-circle',
					// iconPrefix: 'fal',
					href: '#',
					className: 'ml-lg-auto utility',
					level: 1,
					isVisible: false
				},
			]
		},
		// {
		// 	//title: 'Second Item',
		// 	icon: 'heart',
		// 	iconPrefix: 'fal',
		// 	href: '#favorites',
		// 	level: 1
		// },
		{
			//title: 'Three',
			icon: 'shopping-cart',
			iconPrefix: 'fal',
			href: '/cart',
			level: 1
		}
		// ,{
		// 	title: 'TEST',
		// 	// icon: 'shopping-cart',
		// 	// iconPrefix: 'fal',
		// 	//href: '/external',
		// 	href: 'https://www.ascedia.com',
		// 	level: 1,
		// 	// queryParams:{
		// 	// 	url: 'https://www.ascedia.com'
		// 	// }
		// }
	];

	public MainMenuNavItemsAzureb2c: Hyperlink[] = [{
		title: 'Destinations',
		href: '/destinations',
		level: 1,
		className: 'ml-lg-auto d-none'
	}];

	public mainNavSignedInMenuItems = [
		{
			title: 'Travel Advisor Dashboard',
			href: environment.baseHrefDashboard,
			level: 2,
			roles: ['Travel Advisor']
		},
		{
			title: 'My Bookings',
			href: '/account/my-bookings',
			level: 2, 
			roles: [UserRolesEnum.admin, UserRolesEnum.anon, UserRolesEnum.consumer, UserRolesEnum.developer]
		},
		{
			title: 'My Travel Boards',
			href: '/account/my-travel-boards',
			level: 2
		},
		{
			title: 'Sign Out',
			href: '#',
			level: 2
		}
	]


	public bookingStatusEnum = BookingStatusEnum;


	constructor(
		private _titleService: Title
	) {
		//this.test += new Date();
		//console.log('isProduction:', this.isProduction);
		//console.log('environment.baseHref:', environment.baseHref);
	}



	/**
	 * Update badge counter in nav menu for shopping cart
	 * @param badge
	*/
	public updateCartBadge(badge) {
		//console.log('ConfigService.updateCartBadge:', badge);
		let navItem = this.MainMenuNavItems.find(x => x.icon == 'shopping-cart');
		if(navItem) navItem.badge = badge;
	}






	// public doSomething () {
	// 	console.log('doSomething()test:', this.test);
	// }


	/**
	 * Set page title with angular browser title service
	 * TODO-JK: VERIFY THIS WORKS WITH SSR
	 * @param title
	*/
	public setPageTitle(title: string = null) {
		let pageTitle = this.pageTitleBase;
		if(title) {
			pageTitle = title + ' | ' + pageTitle;
		}
		console.log('*** DEPRECATE THIS ONE. MIGRATE TO METASERVICE....setPageTitle:', pageTitle);
		this._titleService.setTitle(pageTitle);
	}



	/**
	 * Compass master list of headers & httpClient config
	 * @returns
	*/
	public getCompassApi(){
		//if(_log) console.log('compassApi', this.compassApi);

		let headers = new HttpHeaders();

		headers = headers.append('Content-Type', 'application/json');
		headers = headers.append('Accept', 'application/json');
		headers = headers.append('Access-Control-Allow-Origin', '*');
		headers = headers.append('Access-Control-Allow-Credentials', 'true');
		headers = headers.append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS');
		headers = headers.append('RequestSiteContext', 'ConsumerSite');
		let headersMulti = new HttpHeaders();

		headersMulti = headersMulti.append('Content-Type', 'multipart/form-data');
		headersMulti = headersMulti.append('Accept', 'application/json');
		headersMulti = headersMulti.append('Access-Control-Allow-Origin', '*');
		headersMulti = headersMulti.append('Access-Control-Allow-Credentials', 'true');
		headersMulti = headersMulti.append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS');
		headersMulti = headersMulti.append('RequestSiteContext', 'ConsumerSite');

		let headersNoContentType = new HttpHeaders();
		headersNoContentType.append('Accept', 'application/json');
		headersNoContentType.append('Access-Control-Allow-Origin', '*');
		headersNoContentType.append('Access-Control-Allow-Credentials', 'true');
		headersNoContentType.append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS');
		headersNoContentType.append('RequestSiteContext', 'AdminDashboardSite');

		const compassApi = {
			//key: 'ASDF',
			baseUrl: this.urls.baseUrl + '/',
			limitMax: this.limitMax,
			headers: headers,
			headersMulti: headersMulti,
			headersNoContentType: headersNoContentType,
			//RequestSiteContext: 'ConsumerSite' // <-- deprecated soon for the headers above ^^
		}

		return compassApi;
	}






	public getClassForBookingStatusColor(status: string) {
		//console.log('getClassForBookingStatusColor:', status);
		let classStatus: string = '';
		switch(String(status)){
			case this.bookingStatusEnum.pendingApproval:
				classStatus = 'status-yellow';
				break;
			case this.bookingStatusEnum.paymentNeeded:
				classStatus = 'status-red';
				break;
			case this.bookingStatusEnum.approved:
				classStatus = 'status-green';
				break;
			case this.bookingStatusEnum.canceled:
				classStatus = 'status-gray';
				break;
			default:
				classStatus = 'status-blue';//inReview
		}
		//console.log('getClassForBookingStatusColor:', status, classStatus);
		return classStatus;
	}
}
